export default async function findLatestPosts(){
    try {
        const response = await fetch('https://back-office-sqbb.fr/wp-json/wp/v2/posts?per_page=4&_embed=true&_sort=desc');
        return  await response.json();
    } catch (err){
        console.error(`ERROR ::: Erreur survenbue lors de la récupération des derniers articles :: ${err}`)
    }
}